import { useCallback } from "react";
import { useForm } from "react-final-form";
import UpIcon from "@mui/icons-material/ArrowUpward";
import DownIcon from "@mui/icons-material/ArrowDownward";

import { StyledOrderButton } from "./OrderListButton.styled";

interface OrderListButtonProps {
  name: string;
  index: number;
  list: unknown[];
}

const OrderListButton = ({ name, index, list }: OrderListButtonProps) => {
  const form = useForm();
  const formValues = form.getState();

  const handleOrder = useCallback(
    (move: number) => {
      const itemToMove = list[index];
      const itemToMoveTo = list[index + move];
      const newList = [...list];
      newList[index + move] = itemToMove;
      newList[index] = itemToMoveTo;
      form.change(name, newList);
    },
    [formValues, list],
  );

  return (
    <div>
      <StyledOrderButton onClick={() => handleOrder(-1)} disabled={index === 0}>
        <UpIcon fontSize="small" />
      </StyledOrderButton>
      <StyledOrderButton
        onClick={() => handleOrder(1)}
        disabled={list.length === index + 1}
      >
        <DownIcon fontSize="small" />
      </StyledOrderButton>
    </div>
  );
};

export default OrderListButton;
